import { Rule } from '../../Rules'

const bugFixesRules: Array<Rule> = [
  {
    details: 'This is the major reason for the fork and the distribution now works correctly.',
    reason: 'With the low distribution and high burn in the original contract, the entire incentive system for the XYO World minting was thrown off.',
    summary: 'Fix for token distribution bug.',
  },
  {
    details: 'The 1.0 contract has a bug where the event that was emitted for the refunding of the bid to the previous bidder did not properly work.',
    reason:
      'The contract was emitting the event after the bidder stored in the contract was set to 0x0 and this always emitted 0x0 as the reciever of the refund.  The actual refund worked correctly, but since this fix is very minor, we decided to fix it in the new contract.',
    summary: 'Fix for RefundedCurrentBidEvent.',
  },
  {
    details: 'The 1.0 contract has a bug where the first parameter of this event was not marked as indexed.',
    reason: 'This is a very minor bug, but by adding indexed to this parameter, it is much easier for clients to query the bids by a given address.',
    summary: 'Fix for BidPlacedEvent.',
  },
]

export default bugFixesRules
